import { render, staticRenderFns } from "./item_title.vue?vue&type=template&id=9657f064"
import script from "./item_title.vue?vue&type=script&lang=js"
export * from "./item_title.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports